'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$HowStep(title, body) {
  this.il = null;
  this.ik = null;
  this.il = title;
  this.ik = body;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$HowStep as $c_Lio_intela_sites_digitalinternship_data_Segments$HowStep };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$HowStep.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$HowStep;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$HowStep() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$HowStep as $h_Lio_intela_sites_digitalinternship_data_Segments$HowStep };
$h_Lio_intela_sites_digitalinternship_data_Segments$HowStep.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, 1900269705, true);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$HowStep) && ((this.il === x$0.il) && (this.ik === x$0.ik))));
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 2;
});
$p.I = (function() {
  return "HowStep";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.il;
  }
  if ((n === 1)) {
    return this.ik;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$HowStep(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bC)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$HowStep as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$HowStep };
var $d_Lio_intela_sites_digitalinternship_data_Segments$HowStep = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$HowStep, "io.intela.sites.digitalinternship.data.Segments$HowStep", ({
  bC: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$HowStep as $d_Lio_intela_sites_digitalinternship_data_Segments$HowStep };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-How-Step.js.map
